<template>
  <v-form ref="form">

    <BaseUtil ref="util" :pageLoading="pageLoading" />

    <v-row>
      <v-col cols="12">
        <v-autocomplete v-model="entry.itemId" v-bind="getObject('itemId')" label="Produto"
          :items="extraData.accountContext.availableItemsForSale" item-value="id" item-text="name"
          @input="selectItem(true)" :hint="itemHint(entry)" persistent-hint :filter="filterNormalizedTextItems"
          autocomplete="off" :disabled="readOnly">
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{ data.item.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ itemHint(data) }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12">
        <v-autocomplete :disabled="!entry.itemId || readOnly" v-model="entry.packagingId"
          v-bind="getObject('packagingId')" label="Embalagem" :items="packagingList" item-value="id" item-text="name"
          @input="selectPackagingInStorage" :loading="packagingListLoading" autocomplete="off"
          persistent-hint
          :hint="entry.itemWeight && entry.itemWeight.grossWeight && entry.itemWeight.liquidWeight ? 'Peso B: ' + (entry.itemWeight.grossWeight+' KG' + ', Peso L: ' + entry.itemWeight.liquidWeight)+ 'KG' : '' "
          >
          <!-- <template v-slot:append-outer>
              <PackagingNew
                :inlineAddButton="true"
                @entry-created="packagingCreated"
              />
            </template> -->
        </v-autocomplete>
      </v-col>

      <v-col cols="12">
        <v-autocomplete :disabled="entry.itemId ? readOnly : true" v-model="entry.storageId"
          v-bind="getObject('storageId')" label="Depósito" :items="storageList" item-value="id" item-text="name"
          @input="selectStorage" :loading="storageListLoading"
          :hint="entry.storage ? entry.storage.quantityInformation ? entry.storage.quantityInformation : 'Quantidade disponível: ' + numberToDecimal(entry.storage.availableQuantity) + ' ' + entry.packaging.basicUnitName : ''"
          persistent-hint autocomplete="off">
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{ data.item.name }}</v-list-item-title>
              <v-list-item-subtitle
                v-if='data.item.quantityInformation'>{{ data.item.quantityInformation }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if='data.item.availableQuantity != ""'>Quantidade disponível:
                {{ numberToDecimal(data.item.availableQuantity) }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" v-if="availableCropLots.cropLots">
        <ExitMovementItemLotsIndex :lotItems="entry.dummyExitMovementItemLotsAttributes" :packaging="entry.packaging"
          :inputData.sync="entry.dummyExitMovementItemLotsAttributes" :itemLots="availableCropLots.cropLots"
          :readOnly="readOnly" :hasTableTitle="true" :addAndEdit="true" />
      </v-col>

      <v-col cols="12" sm="12" md="6">
        <MaskedTextField v-if="renderComponent" :inputData.sync="entry.packagingQuantity" mask-type="currency_10d"
          label="Quantidade de Embalagens" :disabled="!entry.packagingId || readOnly || hasLot"
          @update:inputData="changePackagingQuantity" autocomplete="off"
          :suffix="entry.packaging ? entry.packaging.text : ''" :key="packagingQuantityKey + 'packagingQuantity'" />
        <!--   -->
      </v-col>

      <v-col cols="12" sm="12" md="6" v-if="!this.extraData.accountContext.accountPermissions.isAltavenda">
        <MaskedTextField v-if="renderComponent" v-bind="getObject('quantity')" :inputData.sync="entry.quantity"
          mask-type="currency_10d" label="Quantidade" :suffix="entry.packaging ? entry.packaging.basicUnitName : ''"
          :disabled="!entry.storageId || readOnly || hasLot" @update:inputData="changeQuantity" autocomplete="off"
          :key="quantityKey + 'quantity'" />
      </v-col>

      <!-- Preço da embalagem -->
      <v-col cols="12" sm="12" md="6">
        <MaskedTextField v-if="renderComponent" :inputData.sync="entry.packagingPrice" mask-type="currency_10d"
          label="Preço Embalagem" prefix="R$" :suffix="entry.packaging ? entry.packaging.text : ''"
          :disabled="!entry.packagingId || readOnly" :key="packagingPriceKey + 'packagingPrice'"
          @update:inputData="changePackagingPrice" autocomplete="off" />
      </v-col>

      <v-col cols="12" sm="12" md="6" v-if="!this.extraData.accountContext.accountPermissions.isAltavenda">
        <MaskedTextField v-if="renderComponent" v-bind="getObject('unit_price')" :inputData.sync="entry.unitPrice"
          mask-type="currency_10d" label="Preço" prefix="R$" :disabled="!entry.storageId || readOnly"
          :key="unitPriceKey" @update:inputData="changeUnitPrice" autocomplete="off" />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('discountPercent')"
          :inputData.sync="entry.discountPercent"
          mask-type="12v0-4"
          label="Desconto %"
          :key="discountPercentKey + '_discount'"
          @update:inputData="changeDiscountPercent"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('discount')"
          :inputData.sync="entry.discount"
          mask-type="12v0-4"
          label="Desconto"
          :key="discountKey + '_unit__discount'"
          @update:inputData="changeDiscount"
          :hint="percentDiscount"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <MaskedTextField v-if="renderComponent" v-bind="getObject('price')" :inputData.sync="entry.price"
          mask-type="currency" label="Preço Total" prefix="R$" :disabled="!entry.storageId || readOnly"
          :hint="entry.priceWithDiscount"
          :key="totalPriceKey" @update:inputData="changeTotalPrice" autocomplete="off" />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('totalDiscount')"
          :inputData.sync="entry.totalDiscount"
          mask-type="currency_10d"
          label="Desconto total"
          prefix="R$"
          :key="totalDiscountKey + '_total_discount'"
          autocomplete="off"
          :disabled="true"
        />
      </v-col>

      <v-col cols="12" sm="12" md="6" v-if="entry.isPerformance">
        <MaskedTextField v-if="renderComponent" v-bind="getObject('lossPercentage')"
          :inputData.sync="entry.lossPercentage" mask-type="currency_10d" label="% de perda" prefix=""
          :disabled="!entry.storageId || readOnly" :key="lossPercentagekey" @update:inputData="changeLossPercentage"
          autocomplete="off" />
      </v-col>

      <v-col cols="12" sm="12" md="6" v-if="entry.isPerformance">
        <MaskedTextField v-if="renderComponent" v-bind="getObject('lossQuantity')" :inputData.sync="entry.lossQuantity"
          mask-type="currency_10d" label="Quantidade perdida" prefix="" :disabled="!entry.storageId || readOnly"
          :key="lossQuantitykey" @update:inputData="changeLossQuantity" autocomplete="off" />
      </v-col>

      <v-col cols="12" class="" v-if="entry.isPerformance">
        <StorageAdjustmentIndex :readOnly="readOnly" :hasTableTitle="true" tableTitle="Ajuste de Colheita" :entry="createCrop()" :indexItems="entry.stockAdjustments" :callback="stockAdjustmentsUpdated" />
      </v-col>

    </v-row>
  </v-form>
</template>

<script>

import MultiSelect from "@shared_components/multi_select.vue";
import MaskedTextField from "@shared_components/masked_text_field.vue"
import ExitMovementItemLotsIndex from "@models/sales/sale_products/sale_product_lots/index.vue";
import gql from 'graphql-tag'
import BaseUtil from "@shared_components/base_util.vue";
import StorageAdjustmentIndex from "./crop_adjustments/index.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      storageListLoading: false,
      itemList: [],
      itemListLoading: false,
      storageList: [],
      renderComponent: true,
      unitPriceKey: 1,
      totalPriceKey: -1,
      lossQuantitykey: -1,
      lossPercentagekey: -1,
      quantityKey: 0,
      pageLoading: false,
      packagingListLoading: false,
      packagingList: [],
      packagingQuantity: 0,
      packagingQuantityKey: 0,
      packagingPriceKey: 0,
      availableCropLots: {},
      hasLot: false,
      discountPercentKey: 0,
      productsSearch: "",
      timer: null,
      tablePriceItem: null,
      priceWithoutDiscountKey: 0,
      totalDiscountKey: 0,
      discountKey:0,
      percentDiscount: ""
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MultiSelect: MultiSelect,
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
    ExitMovementItemLotsIndex: ExitMovementItemLotsIndex,
    StorageAdjustmentIndex: StorageAdjustmentIndex,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    // console.log("item sale product", this.entry.item)
    if (this.entry.item) {
      this.selectItem(false);
      this.changeQuantity();
    }

    if(this.extraData.customerId && this.extraData.paymentConditionRuleId && this.entry.packagingId){
      // console.log("buscando");
      this.findTablePriceProduct(); 
    }
  },
  mounted() {
  },
  computed: {
  },
  watch: {
    "entry.dummyExitMovementItemLotsAttributes": {
      handler: function (newValue, oldValue) {
        // console.log("entry edited !!!");
        this.updateExitLots();
      },
      deep: true,
    },
    "entry.packagingId": function(newVale, oldVal){
      // console.log("package change", this.extraData);
      if(this.extraData.customerId && this.extraData.paymentConditionRuleId){
        this.findTablePriceProduct();
        // this.updateQuantity();
      }
    }
  },
  methods: {
    createCrop: function(){
      var crop=new Object;
      crop.storageId = this.entry.storageId;
      crop.movementItemId = this.entry.id;
      var newItem = {item: this.entry.item, itemId: this.entry.itemId, storage: this.entry.storage, storageId: this.entry.storageId, packaging: this.entry.packaging, packagingId: this.entry.packagingId, isNewItemInStorage: false};
      crop.exitMovementItemsAttributes = [];
      crop.entryMovementItemsAttributes = [];
      crop.exitMovementItemsAttributes.push(newItem);
      crop.entryMovementItemsAttributes.push(newItem);
      
      // console.log('comentry', this.entry);
      return crop;
    },
    stockAdjustmentsUpdated: function(){
      // console.log("sa updated");
      this.selectPackagingInStorage(false);
    },
    itemHint: function (data) {
      if (data.item) {
        return 'Unidade de Venda: ' + data.item.unit.name + ' Tipo: ' + data.item.typeText;
      }
      return '';
    },
    getPackagingPrice: function(){
      if(this.tablePriceProduct && this.tablePriceProduct){
        if(this.tablePriceProduct.percentType == 1){
          return this.tablePriceProduct.value / (1- this.tablePriceItem.percent);
        }else{
          return this.tablePriceProduct.value;
        }
      }else{
        return 0;
      }
    },
    changeQuantity: function () {
      this.entry.packagingQuantity = _.round(this.entry.quantity / this.entry.packaging.size, 10);
      this.packagingQuantityKey++;
      this.updateQuantity();
    },
    changePackagingQuantity: function () {
      this.entry.quantity = _.round(this.entry.packagingQuantity * this.entry.packaging.size, 10);
      this.quantityKey++;
      this.updateQuantity();
    },
    updateQuantity: function () {
      // console.log("quantity", this.entry.quantity);
      if (this.entry.unitPrice > 0) {
        this.calculatePackagingPrice();
        this.calculateTotalPrice();
      } else if (this.entry.price > 0) {
        this.calculateUnitPrice();
        this.calculatePackagingPrice();
      } else if(this.entry.packagingPrice > 0){
        this.calculateUnitPrice(false);
        this.calculateTotalPrice();
      } else {
        this.entry.totalPrice = 0;
        this.totalPriceKey--;
        this.entry.price = 0;
        this.unitPriceKey++;
        this.entry.packagingPrice = 0;
        this.packagingPriceKey++;
      }
    },
    changeDiscount: function(){
      var res = ((1-(this.getPackagingPrice(false) - this.entry.discount) / this.getPackagingPrice(false))*100);
      if(res && Number.isFinite(res)){
        this.percentDiscount = "Desconto de aproximadamente " + res.toLocaleString('pt-BR') + "%";
      }
      else{
        this.percentDiscount = "Desconto de 0 %";
        this.entry.priceWithDiscount = "";
      }

      if(this.entry.discountPercent){
        this.entry.discountPercent=null;
        this.discountPercentKey++;
      }
      // this.discountKey++;
      this.calculateTotalPrice();
      // this.changeDiscount();
      // if(this.entry.packagingPrice){
      //   // this.entry.packagingPrice = this.getPackagingPrice(false);
      //   // this.entry
      //   // this.packagingPriceKey++;
      //   this.changePackagingPrice();
      // }else{
      //   // this.entry.packagingPrice = this.getPackagingPrice(false);
      //   // this.packagingPriceKey++;
      //   this.changePackagingPrice();
      // }
    },
    changeDiscountPercent: function(){
      var discounted = _.round((this.getPackagingPrice(false) * (1 - this.entry.discountPercent / 100)), 4);
      // console.log(this.getPackagingPrice(false));
      console.log(discounted);
      this.entry.discount = _.round(this.getPackagingPrice(false) - discounted, 4);
      this.discountKey++;
      this.percentDiscount = "";
      // this.calculateUnitPrice(false);
      this.calculateTotalPrice();
      
    },
    changeUnitPrice: function () {
      // console.log("unitPrice", this.entry.price);
      if (this.entry.quantity > 0) {
        this.calculatePackagingPrice();
        this.calculateTotalPrice();
      }
    },
    changedPackagingPrice: function(){
      // console.log("manual change");
      if(this.tablePriceProduct){
        this.tablePriceProduct.value = this.entry.packagingPrice;
      }
      // this.calculatePackagingPrice();
      this.changePackagingPrice();
    },
    changePackagingPrice: function () {
      if (this.entry.quantity > 0) {
        this.calculateUnitPrice(false);
        this.calculateTotalPrice();
      }
    },
    changeTotalPrice: function () {
      // console.log("totalPrice", this.entry.totalPrice);
      if (this.entry.quantity > 0) {
        this.calculateUnitPrice();
        this.calculatePackagingPrice();
      }
    },
    calculateTotalPrice: function() {
      this.entry.price = _.round((this.entry.unitPrice ? this.entry.unitPrice : 0) * (this.entry.quantity ? this.entry.quantity : 0), 2);
      this.totalPriceKey--;

      // if(this.tablePriceProduct){
        this.entry.priceWithoutDiscount = _.round((this.getPackagingPrice(false)) * (this.entry.packagingQuantity ? this.entry.packagingQuantity : 0), 2);
        this.priceWithoutDiscountKey++;
        this.entry.totalDiscount = _.round(this.entry.discount * this.entry.packagingQuantity, 2);
        this.totalDiscountKey++;
        if(this.entry.discount){
          this.entry.priceWithDiscount = "por: " + this.toLocalString(this.entry.price - this.entry.totalDiscount);
          this.entry.liquidPrice = this.entry.price - this.entry.totalDiscount;

        }
      // }
    },
    toLocalString: function(val){
      return val.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    calculateUnitPrice: function(byTotalPrice=true) {
      if (byTotalPrice) {
        this.entry.unitPrice = _.round((this.entry.price ? this.entry.price : 0) / (this.entry.quantity ? this.entry.quantity : 0), 10);
      } else { //calcula pelo preco unitario com base no preco da embalagem
        // console.log("pack", this.entry.packaging);
        if(this.tablePriceProduct){
          this.entry.unitPrice = _.round((this.getPackagingPrice(false)) / (this.entry.packaging.size ? this.entry.packaging.size : 0), 10);
        }else{
          this.entry.unitPrice = _.round(this.entry.packagingPrice / this.entry.packaging.size, 10);  
        }
        // console.log(this.entry.unitPrice);
      }
      this.unitPriceKey++;
    },
    calculatePackagingPrice: function () {
      this.entry.packagingPrice = _.round((this.entry.unitPrice ? this.entry.unitPrice : 0) * (this.entry.packaging.size ? this.entry.packaging.size : 0), 10);
      this.packagingPriceKey++;
    },
    getObject: function (element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function () {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function () {
          document.querySelector(".v-messages.error--text:first-of-type")?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function () {
      this.$refs.form.resetValidation();
    },
    getPackagingPrice: function(withDiscount=true){
      if(this.tablePriceProduct && this.tablePriceItem && !this.isEdit){
        if(this.tablePriceItem.percentType == 0){
          // console.log("type1");
          return _.round((this.tablePriceProduct.value / (1 - this.tablePriceItem.percent/100)), 2);
        }else{
          // console.log("type0");
          var res = this.tablePriceProduct.value * (this.entry.discountPercent > 0 ? (1-(this.entry.discountPercent/100)) : 1)
          // console.log(res);
          if(withDiscount){
            return res;
          }else{
            return this.tablePriceProduct.value;
          }
        }
      }else{
        return this.entry.packagingPrice;
      }
    },
    changeLossPercentage: function () {
      // console.log("loss %");      
      this.entry.lossQuantity = this.entry.quantity * (this.entry.lossPercentage / 100.0);
      this.lossQuantitykey--;
    },
    changeLossQuantity: function () {
      // console.log("totalPrice", this.entry.totalPrice);
      // var qtd = ((this.entry.lossQuantity * 10000000.0 ) / this.entry.quantity) / 100000.0;
      // if(qtd>1){
      //   this.entry.lossPercentage = qtd;
      //   this.lossPercentagekey--;
      // }
      // this.entry.lossPercentage = null;
      // this.lossPercentagekey--;
    },
    selectItem: function (clearPackagingAndStorage) {
      // console.log(this.extraData.accountContext.availableItemsForSale)
      this.entry.item = this.extraData.accountContext.availableItemsForSale.find(obj => obj.id == this.entry.itemId);
      this.packagingList = [];

      this.clearFields();
      if (clearPackagingAndStorage) {
        this.entry.packagingId = null;
        this.entry.packaging = null;
        this.entry.storageId = null;
        this.entry.storage = null;
        while (this.entry.dummyExitMovementItemLotsAttributes?.length > 0) {
          this.entry.dummyExitMovementItemLotsAttributes.pop();
        }
      }
      this.packagingListLoading = true;
      this.$apollo
        .query({
          query: AVAILABLE_PACKAGINGS_FOR_SALE_ITEM_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            itemId: this.entry.itemId,
            dummyExitMovementItemId: this.entry.id
          }
        })
        .then(response => {
          // console.log("response dos packaging", response);
          this.packagingList = response.data.accountContext.availableItemPackagingsForSale;
          // console.log("packagingList", this.packagingList);
          let clearStorage = false;
          if (this.packagingList.length == 1 && !this.entry.packagingId) {
            this.entry.packagingId = this.packagingList[0].id;
            clearStorage = clearPackagingAndStorage;
          }
          this.selectPackagingInStorage(clearStorage);
        })
        .catch(response => console.log(response))
        .finally(() => (this.packagingListLoading = false));
    },
    selectPackagingInStorage: function (clearStorage = false) {
      if (this.entry.packagingId) {
        this.entry.packaging = this.packagingList.find(obj => obj.id == this.entry.packagingId);

        this.storageListLoading = true;
        // console.log("entry", this.entry);
        // this.entry.packagingUnitName = this.entry.packaging.customUnit?.name ?? this.entry.packaging.unit.name
        this.$apollo
          .query({
            query: AVAILABLE_ITEMS_FOR_SALE_IN_STORAGE,
            fetchPolicy: "no-cache",
            variables: {
              itemId: this.entry.itemId,
              packagingId: this.entry.packagingId
            }
          })
          .then(response => {
            this.storageList = response.data.accountContext.storagesWithAvailableItemForSale;
            this.entry.itemWeight = response.data.accountContext.getItemWeight;
            // console.log("storageList", this.storageList);
            // this.storageList.forEach(
            //   function(value, index){
            //     value.id = value.id+'-'+index;
            //   }
            // );
            if (this.storageList.length == 1 && !this.entry.storageId) {
              this.entry.storageId = this.storageList[0].id;
            }
            this.selectStorage();
          })
          .catch(response => console.log(response))
          .finally(() => (this.storageListLoading = false));
      }
    },
    updateExitLots: function () {
      if (this.entry.dummyExitMovementItemLotsAttributes) {
        var reduced = 0;
        this.entry.dummyExitMovementItemLotsAttributes.forEach((object) => {
          // console.log("packaging quantity:", object.packagingQuantity);
          if (typeof object._destroy == 'undefined' || object._destroy == false) {
            reduced += parseFloat(object.packagingQuantity);
          }
        });

        this.entry.packagingQuantity = reduced;
        this.packagingQuantityKey++;
        this.changePackagingQuantity();
      }
    },
    loadAvailableCropLots: function () {
      this.$apollo
        .query({
          query: AVAILABLE_CROP_LOTS_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            itemId: this.entry.itemId,
            storageId: this.entry.storageId,
            packagingId: this.entry.packagingId
          }
        })
        .then(response => {
          this.availableCropLots = response.data.accountContext.availableCropLots;
          if (this.availableCropLots.cropLots?.length > 0) {
            this.hasLot = true;
          } else {
            this.hasLot = false;
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.packagingListLoading = false));
    },

    getItems: function() {
      this.itemsListLoading = true;
      this.$apollo
        .query({
          query: ALL_ITEMS_QUERY,
          variables: {
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.itemsList = response.data.accountContext.allItems;
        })
        .catch(response => console.log(response))
        .finally(() => (this.endProductsListLoading = false));
    },

    findTablePriceProduct: function() {
      // this.storageListLoading = true;
      // console.log("extraData", this.extraData);
      this.$apollo
        .query({
          query: FIND_TABLE_PRICE_PRODUCT,
          fetchPolicy: "no-cache",
          variables: {
            itemId: this.entry.itemId,
            packagingId: this.entry.packagingId,
            customerId: this.extraData.customerId,
            paymentConditionRuleId: this.extraData.paymentConditionRuleId,
          }
        })
        .then(response => {
          this.tablePriceProduct = response.data.accountContext.findTablePriceProduct;
          // console.log("this.tablePriceProduct", this.tablePriceProduct);
          this.tablePriceItem = response.data.accountContext.findTablePriceItem;
          // console.log("this.tablePriceItem", this.tablePriceItem);
          if(this.tablePriceItem){
            if(this.tablePriceItem.percentType == 0){
              // console.log("percemnt", this.tablePriceItem.percent);
              if(!this.isEdit){
                this.entry.packagingPrice = _.round (this.tablePriceProduct.value / (1-(this.tablePriceItem.percent/100)), 2);
              }
              // this.entry.unitPrice = this.entry.packagingPrice / this.packaging.size;
            }else{
              if(!this.isEdit){
                this.entry.packagingPrice = this.tablePriceProduct.value;
              }
            }
            // console.log("aqui");
            this.entry.tablePriceValue = this.entry.packagingPrice;
            // console.log(this.entry);
          }else{
            this.entry.packagingPrice = null;
            // console.log("tablepriceitem not found");
          }
          // this.entry.packagingPrice = this.tablePriceProduct.value;
          this.packagingPriceKey++;

          if(this.entry.discount){
            this.changeDiscount();
          }
          this.changePackagingPrice();
          // this.updateQuantity();
        })
        .catch(response => console.log(response))
        .finally(() => (this.storageListLoading = false));
    },

    selectStorage: function () {
      this.entry.storage = this.storageList.find(obj => obj.id == this.entry.storageId);
      // this.entry.storageId = this.entry.storageId?.split("-")[0];
      // console.log("storageId",this.entry.storageId);
      this.entryAttributes.quantity.rules = [];
      this.entryAttributes.quantity.rules.push(this.requiredRule);
      this.entryAttributes.quantity.rules.push(this.minRequiredRule);
      this.entryAttributes.quantity.rules.push(this.maxValueRule(this.entry.storage.availableQuantity));

      this.entryAttributes.price.rules = [];
      this.entryAttributes.price.rules.push(this.requiredRule);
      this.entryAttributes.price.rules.push(this.minRequiredRule);
      this.clearFields();

      this.loadAvailableCropLots();
    },
    clearFields: function () {
      this.forceRerender(this);
    },
  }
};

const AVAILABLE_ITEMS_FOR_SALE_IN_STORAGE = gql`
  query ($itemId: ID!, $packagingId: ID!) {
    accountContext {
      storagesWithAvailableItemForSale(itemId: $itemId, packagingId: $packagingId) {
        id
        name
        availableQuantity
        quantityInformation
        type
      }
      getItemWeight(itemId: $itemId, packagingId: $packagingId) {
        grossWeight
        liquidWeight
      }
    }
  }
`;

const AVAILABLE_PACKAGINGS_FOR_SALE_ITEM_QUERY = gql`
  query ($itemId: ID!, $dummyExitMovementItemId: ID) {
    accountContext {
      availableItemPackagingsForSale(itemId: $itemId, dummyExitMovementItemId: $dummyExitMovementItemId){
        id
        name
        size
        text
        unit{
          id
          name
        }
        customUnit{
          name
        }
        basicUnitName
      }
    }
  }
`;


const AVAILABLE_CROP_LOTS_QUERY = gql`
  query ($itemId: ID!, $packagingId: ID!, $storageId: ID!) {
    accountContext {
      availableCropLots(itemId: $itemId, packagingId: $packagingId, storageId: $storageId)
    }
  }
`;

const ALL_ITEMS_QUERY = gql `
  query {
    accountContext {
      allItems{
        id
        name
        typeText
      }
    }
  }
`;

const FIND_TABLE_PRICE_PRODUCT = gql `
  query ($itemId: ID!, $packagingId: ID!, $customerId: ID!, $paymentConditionRuleId: ID!) {
    accountContext {
      findTablePriceProduct(itemId: $itemId, packagingId: $packagingId, customerId: $customerId, paymentConditionRuleId: $paymentConditionRuleId) {
        id
        value
        commissionPercent
      }
      findTablePriceItem(itemId: $itemId, customerId: $customerId, paymentConditionRuleId: $paymentConditionRuleId){
        percent
        percentType
        discountAddition
      }
    }
  }
`;

</script>

<style scoped></style>
